import { validateNewEmailExistsApi } from "@/api/services/main/auth";
import { useGetUserSettingInfo } from "@/api/services/main/user-setting";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { ChangeEmailForm } from "@/features/user-setting/components/setting-form/ChangeEmailForm";
import { ChangeEmailConfirmPage } from "@/features/user-setting/pages/ChangeEmailConfirmPage";
import { useGetUserSettingEmailSchema } from "@/features/user-setting/schema/userSettingEmailSchema";
import { TUserSettingEmailForm } from "@/features/user-setting/types/UserSettingEmailForm";
import { showError, setErrorForm } from "@/utils/error";
import { yupResolver } from "@hookform/resolvers/yup";
import { FC, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";

type TUserSettingChangeEmailPageProps = {};

export const UserSettingChangeEmailPage: FC<TUserSettingChangeEmailPageProps> = () => {
  const { data: userSettingResult, isLoading } = useGetUserSettingInfo();
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [searchParams] = useSearchParams();
  const emailParam = searchParams.get("email");

  const userSettingEmailSchema = useGetUserSettingEmailSchema({
    currentEmail: userSettingResult?.data.userEmail ?? "",
  });

  const methods = useForm<TUserSettingEmailForm>({
    defaultValues: emailParam ? { email: emailParam } : {},
    resolver: yupResolver(userSettingEmailSchema),
  });

  const handleConfirm = async (data: TUserSettingEmailForm) => {
    try {
      const response = await validateNewEmailExistsApi({ email: data.email });
      if (response.data) {
        setIsConfirmed(true);
      }
    } catch (error) {
      showError(error);
      setErrorForm(methods, error);
    }
  };

  if (isLoading) return <LoadingPage />;

  if (!isConfirmed && !emailParam) {
    return (
      <ChangeEmailForm
        methods={methods}
        currentEmail={userSettingResult?.data.userEmail ?? ""}
        handleConfirm={handleConfirm}
        schema={userSettingEmailSchema}
      />
    );
  }

  return (
    <ChangeEmailConfirmPage
      methods={methods}
      currentEmail={userSettingResult?.data.userEmail ?? ""}
      newEmail={emailParam ?? methods.getValues("email")}
    />
  );
};
